export const LANDING = "/";
export const BOOKING = "/booking";
export const CREATE = "/create";
export const EDIT = "/edit/:id";
export const ADMIN = "/admin";